import React from 'react';
import { FileIcon, ImageIcon, FileText, Globe } from 'lucide-react';
import type { SourceKind } from '@/lib/models/source';

// Per-kind colored icon used in the source rail (compact + expanded
// modes) and the dashboard source library. Pulled out as its own
// component so both surfaces render the same icon.
//
// Colors are intentional: PDF rose, image violet, text emerald, URL
// sky. Mirrors the chat sidebar's original palette.
export const SourceIcon: React.FC<{ kind: SourceKind; className?: string }> = ({
    kind,
    className = 'w-3.5 h-3.5 flex-shrink-0',
}) => {
    if (kind === 'pdf') return <FileIcon className={`${className} text-rose-600`} />;
    if (kind === 'image') return <ImageIcon className={`${className} text-violet-600`} />;
    if (kind === 'text') return <FileText className={`${className} text-emerald-600`} />;
    return <Globe className={`${className} text-sky-600`} />;
};
